<template>
  <div>
    <div class="card">
      <div class="card-header"><h4>Nova Loja</h4></div>
      <div class="card-body">
        <div class="tab-content" id="pills-tabContent">
          <div
            class="tab-pane fade show active"
            id="pills-home"
            role="tabpanel"
            aria-labelledby="pills-home-tab"
          >
            <div class="row">
              <div class="col-md-3">
                <label for="nome">Nome</label>
                <input
                  id="nome"
                  type="text"
                  class="form-control"
                  placeholder="Digite um nome:"
                  v-model="state.loja.nome.value"
                />
                <span v-if="state.loja.nome.error" class="text-danger"
                  >Este campo é obrigatório</span
                >
              </div>
              <div class="col-md-3">
                <label for="telefone">Telefone</label>
                <input
                  id="telefone"
                  type="text"
                  class="form-control"
                  placeholder="Digite um telefone:"
                  v-mask-phone.br
                  v-model="state.loja.telefone.value"
                />
                <span v-if="state.loja.telefone.error" class="text-danger"
                  >Este campo é obrigatório</span
                >
              </div>
              <div class="col-md-3">
                <label>Categoria</label>
                <select
                  class="form-select"
                  v-model="state.loja.categoria_loja_id.value"
                >
                  <option
                    :value="categoria.id"
                    v-for="categoria in state.categoria_loja"
                    :key="categoria.id"
                  >
                    {{ categoria.nome }}
                  </option>
                </select>
                <span
                  v-if="state.loja.categoria_loja_id.error"
                  class="text-danger"
                  >Este campo é obrigatório</span
                >
              </div>
              <div class="col-md-3">
                <label for="endereco">Estado</label>
                <select
                  class="form-select"
                  v-model="state.loja.estado_id.value"
                >
                  <option
                    :value="estado.id"
                    v-for="estado in state.estados"
                    :key="estado.id"
                  >
                    {{ estado.nome }}
                  </option>
                </select>
                <span v-if="state.loja.estado_id.error" class="text-danger"
                  >Este campo é obrigatório</span
                >
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <label for="endereco">Endereço</label>
                <input
                  id="endereco"
                  type="text"
                  class="form-control"
                  v-model="state.loja.endereco.value"
                  placeholder="Digite um endereço:"
                />
                <span v-if="state.loja.estado_id.error" class="text-danger"
                  >Este campo é obrigatório</span
                >
              </div>
            </div>
          </div>
        </div>
        <div class="btns_right">
          <button @click="salvarLoja" type="button" class="btn_save">
            Salvar
          </button>
          <router-link to="/lojas">
            <button type="button" class="btn_cancel">Cancelar</button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { onMounted, reactive } from "vue";
import { useRouter } from "vue-router";
import services from "../../services";
import { useStorage } from "vue3-storage";
export default {
  setup() {
    const router = useRouter();
    const storage = useStorage();
    var token = storage.getStorageSync("token");
    const state = reactive({
      loja: {
        id: "",

        nome: {
          value: "",
          error: false,
        },
        telefone: {
          value: "",
          error: false,
        },
        estado_id: {
          value: "",
          error: false,
        },
        categoria_loja_id: {
          value: "",
          error: false,
        },
        endereco: {
          value: "",
          error: false,
        },
      },
      categoria_loja: [],
      estados: [],
    });
    onMounted(() => {
      fetchCategoria();
      fetchEstados();
      if (router.currentRoute._value.params.id != undefined) {
        fetchLoja();
      }
    });
    async function fetchLoja() {
      try {
        const { data } = await services.lojas.getById({
          id: router.currentRoute._value.params.id,
          token,
        });
        state.loja.id = data.id;
        state.loja.nome.value = data.nome;
        state.loja.telefone.value = data.telefone;
        state.loja.estado_id.value = data.estado_id;
        state.loja.categoria_loja_id.value = data.categoria_loja_id;
        state.loja.endereco.value = data.endereco;
      } catch (error) {
        console.log(error);
      }
    }
    async function fetchCategoria() {
      try {
        const { data } = await services.categoria_loja.getAll({
          token,
        });
        console.log(data);
        state.categoria_loja = data;
      } catch (error) {
        console.log(error);
      }
    }
    async function fetchEstados() {
      try {
        const { data } = await services.estado.getAll({
          token,
        });
        console.log(data);
        state.estados = data;
      } catch (error) {
        console.log(error);
      }
    }

    async function salvarLoja() {
      var erro_validacao = false;
      if (state.loja.nome.value.length == 0) {
        state.loja.nome.error = true;
        erro_validacao = true;
      }
      if (state.loja.telefone.value.length == 0) {
        state.loja.telefone.error = true;
        erro_validacao = true;
      }
      if (state.loja.categoria_loja_id.value.length == 0) {
        state.loja.categoria_loja_id.error = true;
        erro_validacao = true;
      }
      if (state.loja.estado_id.value.length == 0) {
        state.loja.estado_id.error = true;
        erro_validacao = true;
      }
      if (state.loja.endereco.value.length == 0) {
        state.loja.endereco.error = true;
        erro_validacao = true;
      }
      if (erro_validacao == true) {
        return;
      }

      let dados = new FormData();
      dados.append("nome", state.loja.nome.value);
      var value = state.loja.telefone.value;
      var clean = value.replace(/[^0-9,]*/g, "");
      state.loja.telefone.value = clean;
      dados.append("telefone", state.loja.telefone.value);
      dados.append("estado_id", state.loja.estado_id.value);
      dados.append("categoria_loja_id", state.loja.categoria_loja_id.value);
      dados.append("endereco", state.loja.endereco.value);
      if (!state.loja.id) {
        await services.lojas
          .save({ dados, token })
          .then((data) => {
            console.log(data);
            router.push({ name: "Lojas" });
          })
          .catch((error) => {
            console.log(error);
            var valores = Object.values(error.response.data.errors);
            alert(valores);
          });
      } else {
        dados.append("id", state.loja.id);
        dados.append("_method", "PATCH");
        await services.lojas
          .update({ dados, token })
          .then((data) => {
            console.log(data);
            router.push({ name: "Lojas" });
          })
          .catch((error) => {
            console.log(error);
            var valores = Object.values(error.response.data.errors);
            alert(valores);
          });
      }
    }
    return {
      salvarLoja,
      router,
      state,
    };
  },
};
</script>
<style scoped>
h4 {
  color: #000;
}
label {
  color: #000;
  font-size: 12pt;
  margin-bottom: 0;
  margin-top: 5px;
}
input {
  border: solid 1px #000;
}
input:focus {
  border: solid 1px #47b0a9;
}
select {
  border: solid 1px #000;
}
select:focus {
  border: solid 1px #47b0a9;
}
.btns_right {
  text-align: right;
  margin-top: 1rem;
}
.btn_save {
  padding: 5px;
  width: 100px;
  background: #00a000;
  border: solid 2px #000;
  border-radius: 5px;
  transition: 0.2s;
}
.btn_save:hover {
  background: #008000;
}
.btn_cancel {
  padding: 5px;
  width: 100px;
  background: #c4342d;
  border: solid 2px #000;
  border-radius: 5px;
  margin-left: 10px;
  transition: 0.2s;
}
.btn_cancel:hover {
  background: #8f0303;
}
.card {
  border: solid 2px #000;
  border-radius: 10px;
  background-color: #fff;
}
textarea {
  resize: none;
  border: solid 1px #000;
}
textarea:focus {
  border: solid 1px #47b0a9;
}
#pills-home-tab {
  color: #000;
}
#pills-home-tab:focus {
  color: #47b0a9;
}
#pills-profile-tab {
  color: #000000;
}
#pills-profile-tab:focus {
  color: #47b0a9;
}
.btn-add {
  color: #000;
  padding: 5px;
  width: 100px;
  background: orange;
  border: solid 2px #000;
  border-radius: 5px;
  margin-left: 10px;
  transition: 0.2s;
}
.btn-add:hover {
  background: rgb(208, 135, 1);
  color: #000;
}
tr {
  border-bottom: solid 1px rgb(0, 0, 0);
}
thead {
  color: #000;
  text-align: center;
  background: gray;
}
td {
  color: #000;
  text-align: center;
}
.table {
  margin-top: 2rem;
}
.imagem {
  width: 200px;
  height: 200px;
  -o-object-fit: cover;
  object-fit: cover;
  margin-top: 2rem;
  border: solid 2px #4bafa9;
  border-radius: 100%;
}
.btn_deletar_imagem {
  margin-left: 10px;
  height: 30px;
  width: 30px;
  margin-top: 2rem;
  background: #c4342d;
  color: #000;
  border: solid 1px #000;
  border-radius: 5px;
  transition: 0.2s;
}
.btn_deletar_imagem:hover {
  background: #8f0303;
  border: solid 1px #000;
}
</style>